module.exports = __webpack_public_path__ + "static/img/patho-yeasts-item-fGWvQrg5.6c823685.png";